export default __webpack_public_path__ + "static/media/showroom29.61b1d6af.webp";